<script setup lang="ts">
import { ref } from "vue"

import TeleworkForm from "@/components/benefits/TeleworkForm.vue"
import TeleworkHistory from "@/components/benefits/TeleworkHistory.vue"
import { Button } from "@/components/ui/button"
import { dateFormatter } from "@/lib/formatters"
import { formatPrice } from "@/lib/utils"
import chairImg from "/chair.webp?url"
import monitorImg from "/monitor.webp?url"
import type { Telework, TeleworksShow } from "@/types/serializers"

type TeleworkItemType = "chair" | "monitor"

const isOpen = ref(false)

defineProps<{
  data: Telework | null
  canApply: boolean
  itemType: TeleworkItemType
  settings: TeleworksShow["settings"][TeleworkItemType]
}>()
</script>

<template>
  <div class="flex w-full flex-col">
    <div class="bg-background z-1 flex flex-col rounded-xl border p-4">
      <div class="flex h-full grow justify-between">
        <div class="flex flex-col justify-between">
          <p class="text-xl font-bold">
            {{ itemType == "chair" ? "Silla Ergonomica" : "Monitor" }}
          </p>
          <div v-if="canApply">
            <p>Disponible</p>
            <p class="text-lg font-bold">
              {{ formatPrice(settings.limit, { minFD: 0 }) }}
            </p>
          </div>
        </div>

        <div>
          <img
            width="112"
            height="112"
            class="size-28"
            :src="itemType == 'chair' ? chairImg : monitorImg"
            alt="preview"
          />
        </div>
      </div>

      <TeleworkForm
        v-if="isOpen"
        :item-type="itemType"
        @success="isOpen = false"
      />
      <Button
        v-else-if="canApply"
        size="lg"
        class="mt-4 w-fit"
        @click="isOpen = true"
      >
        Solicitar Reembolso
      </Button>
      <div v-else class="opacity-70">
        <p>Renovación</p>
        <p class="text-lg font-bold">
          {{ data?.till ? dateFormatter(data.till, {}, "date") : "—" }}
        </p>
      </div>
    </div>

    <TeleworkHistory
      v-if="data"
      class="-mt-6 rounded-b-xl border-x border-b pt-10"
      v-bind="data"
    />
  </div>
</template>
